import React from 'react'

const Form = () => {
    return (
        <section className='px-4 py-12 md:py-28 bg-[#F6F9FB]'>
            <div className='max-w-7xl w-full mx-auto'>
                <div className='flex flex-col justify-center items-center'>
                    <h2 className='text-2xl md:text-4xl font-bold mb-4 text-headings text-center'>Partner With Tuber Today!</h2>

                    <p className='text-light_black max-w-[800px] text-sm md:text-lg mb-6 mx-auto text-center'>
                        Tuber is transforming trade logistics, helping businesses save time, increase efficiency, and
                        keep projects on schedule. Whether you're a sole trader, a large construction company, or a
                        supplier, partnering with Tuber means faster, more reliable deliveries.
                    </p>

                    <button className='py-[14px] px-[30px] rounded-md bg-primary text-white uppercase text-base font-medium w-fit hover:opacity-90 transition duration-300'>Get Started</button>
                </div>


                <div class="max-w-[1000px] mt-16 mx-auto shadow-shadow-3 bg-white py-10 px-5 md:px-10">
                    <h2 class="text-lg text-light_black font-medium mb-6">Tell us more about your business below</h2>
                    <form class="space-y-5">
                        <div>
                            <label class="block font-medium text-[#231f20] mb-1">Email<span class="text-red-500">*</span></label>
                            <input type="email" class="w-full bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary" required />
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div>
                                <label class="block font-medium text-[#231f20] mb-1">First Name<span class="text-red-500">*</span></label>
                                <input type="text" class="w-full bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary" required />
                            </div>
                            <div>
                                <label class="block font-medium text-light_black">Last Name<span class="text-red-500">*</span></label>
                                <input type="text" class="w-full bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary" required />
                            </div>
                        </div>

                        <div>
                            <label class="block font-medium text-[#231f20] mb-1">Your Business Name<span class="text-red-500">*</span></label>
                            <input type="text" class="w-full bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary" required />
                        </div>

                        <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                            <div>
                                <label class="block font-medium text-[#231f20] mb-1">Mobile Phone Number<span class="text-red-500">*</span></label>
                                <input type="tel" class="w-full bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary" required />
                            </div>
                            <div>
                                <label class="block font-medium text-[#231f20] mb-1">Business Phone Number</label>
                                <input type="tel" class="w-full bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary" />
                            </div>
                        </div>

                        <div>
                            <label class="block font-medium text-[#231f20] mb-1">Your estimated delivery volume per month<span class="text-red-500">*</span></label>
                            <select class="w-full custom-select bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary" name="delivery_volume" required>
                                <option disabled="" value="">Please Select</option>
                                <option value="1-10">1-10</option>
                                <option value="11-50">11-50</option>
                                <option value="51-100">51-100</option>
                                <option value="101-500">101-500</option>
                                <option value="501-1000">501-1000</option>
                                <option value="1001-3000">1001-3000</option>
                                <option value="3001-5000">3001-5000</option>
                                <option value="5000+">5000+</option>
                                <option value="One-Off">One-Off</option>
                            </select>

                        </div>

                        <div>
                            <label class="block font-medium text-[#231f20] mb-1">Which cities you need delivery service for?</label>
                            <input type="text" class="w-full bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary" />
                        </div>

                        <div>
                            <label class="block font-medium text-[#231f20] mb-1">Tell us a bit more about your business</label>
                            <textarea rows="4" class="w-full bg-[#f6f9fb] border border-[#cbd6e2] rounded-md text-[#231f20] p-[10px] focus:outline-none focus:ring-1 focus:ring-primary"></textarea>
                        </div>

                        <button type="submit" class="w-full bg-primary px-6 py-3 font-semibold rounded-md text-white uppercase hover:opacity-90 transition duration-300">
                            Submit
                        </button>
                    </form>
                </div>

            </div>
        </section>
    )
}

export default Form